import React, { useState } from 'react';
import { Card, CardContent } from '@frontend/shadcn/components/ui/card';
import { P } from '@frontend/shadcn/components/typography/p';
import { H3 } from '@frontend/shadcn/components/typography/h3';
import { cn } from '@frontend/shadcn/lib/utils';
import { ChevronUpIcon, ChevronDownIcon } from '@revfluence/fresh-icons/regular/esm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';

interface ISectionCardCollapsableProps {
  children: React.ReactNode;
  icon?: React.ReactNode;
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  description?: React.ReactNode;
  stepNumber?: number;
  totalSteps?: number;
  isCompleted?: boolean;
  defaultExpanded?: boolean;
  className?: string;
}

export const SectionCardCollapsable: React.FC<ISectionCardCollapsableProps> = ({
  children,
  icon,
  title,
  subtitle,
  description,
  stepNumber,
  totalSteps,
  isCompleted = false,
  defaultExpanded = true,
  className,
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <Card className={cn('border border-border shadow-none rounded-xl', className)}>
      <CardContent className="p-6">
        <div className="flex flex-col gap-6">
          <div
            className="flex flex-row justify-between items-start cursor-pointer"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            <div className="flex flex-col gap-2">
              <div className="flex items-center gap-2">
                {icon}
                <P className="text-[#162428] mb-0">{title}</P>
              </div>
              {subtitle && (
                <H3 className="font-medium text-[#162428] text-lg mb-0">{subtitle}</H3>
              )}
              {description && (
                <P className="text-primaryMuted">{description}</P>
              )}
            </div>
            <div className="flex items-center gap-2">
              {(stepNumber && totalSteps) && (
                <div className="flex items-center gap-1">
                  {isCompleted && (
                    <FontAwesomeIcon icon={faCircleCheck} className="w-4 h-4 text-green-500" />
                  )}
                  <P className="text-[#5D6770] mb-0">Step {stepNumber} of {totalSteps}</P>
                </div>
              )}
              {isExpanded ? (
                <ChevronUpIcon className="text-[#A3A9B0] w-4 h-4" />
              ) : (
                <ChevronDownIcon className="text-[#A3A9B0] w-4 h-4" />
              )}
            </div>
          </div>

          <div className={cn(
            'transition-all duration-200',
            !isExpanded && 'hidden'
          )}
          >
            {children}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
